import {
  ChangeDetectorRef,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  EventEmitter,
  Output,
} from "@angular/core";
import {
  NgbDate,
  NgbCalendar,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "../../../services/userService/user.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import * as moment from "moment";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Sort } from "@angular/material/sort";
import { environment } from "../../../../environments/environment";
import * as XLSX from "xlsx";

@Component({
  selector: "app-contacts",
  templateUrl: "./contacts.component.html",
  styleUrls: ["./contacts.component.css"],
})
export class ContactsComponent implements OnInit {
  @ViewChild("showimport") showimport: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() clearEvent = new EventEmitter<void>();
  displayedColumns: string[] = [
    "ContactName",
    "CompanyName",
    "Designation",
    "City.Country",
    "Email",
    "Mobile",
    "ContactOwner",
    "Status",
    "Action",
  ];

  sortData: any = { column: "ContactName", direction: "asc" };

  dataSource: any;
  CountryName: any;
  shortcountryname: any;
  shortname: any;
  comid: any;
  companyListArray: any;
  dtOptions: any = {};
  countryListArray: any = [];
  dropdownSettings: any = {};
  dropdownSetting1: any = {};
  dropdownSetting2: any = {};
  dropdownSetting3: any = {};
  dropdownSetting4: any = {};
  dropdownSetting5: any = {};
  dropdownSetting6: any = {};
  dropdownSetting7: any = {};
  dropdownSetting8: any = {};
  CountryList: any = [];
  stateList: any = [];
  dropdownCity;
  any = {};
  cityArray: any = [];
  cityList: any = [];
  ReservationList: any = [];
  ReligionList: any = [];
  LanguageList: any = [];
  date_range: any = { startDate: moment, endDate: moment };
  start_date: string;
  end_date: string;
  timezone: any;
  selectedItems = [];
  designationArray: any = [];
  CompanyArray: any = [];
  ReligionArray: any = [];
  LanguageArray: any = [];
  ReservationArray: any = [];
  isExcelFile: boolean;
  dropdownower: any = {};
  downicon: boolean = true;
  upicon: boolean = true;
  columnsort: any;
  CompanyList: any = [];
  designationList: any = [];
  submitted1 = false;

  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  invalidDates: moment.Moment[] = [
    moment().add(2, "days"),
    moment().add(3, "days"),
    moment().add(5, "days"),
  ];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some((d) => d.isSame(m, "day"));
  };
  currentPage: any = 0;
  pageSize: any = 10;
  totalSize: any = "";

  //Date range
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  contactListArray: any;
  err_message: any;
  status_id: any;
  sta_type: any;
  deleteId: any;
  file: any;
  modalRef: any;
  baseurl: any;
  upfile: File;
  inputFile: any;
  data: any;
  showcompany: string[];
  dataSheet: any;
  permission: any;
  delstatus: any;
  selecteddate_range: any[];
  selectedselect_date: any[];
  showaccount: any;
  ownerList: any = [];
  userid: any;
  restoreId: any;
  files: any;
  TotalRecord: any;
  selectedItems5: {};
  status: any;
  name: any;
  mailText: string;
  mailid: any;
  type: string;
  namesort: string;
  roleid: any;
  resetPagination: boolean = false;
  Totalrec: any = 0;
  invalid: any = 0;
  valid: any = 0;
  dataarray: any = [];
  error: any = [];
  count: any;
  modelref: BsModalRef;
  isValid: boolean = false;
  sampleContactExl: any;
  arrHeader: any = [];
  showcontact: any = [];
  StatusForm: FormGroup;
  ConStatus: any;

  constructor(
    calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private toastr: ToastrService,
    private router: Router,
    private UserService: UserService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private changeDetectorRefs: ChangeDetectorRef,
    private modalService: BsModalService,
    private formBuilder: FormBuilder
  ) {
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), "d", 10);
  }
  showTable: any = false;

  isCollapsed: boolean = false;

  registerForm = this.formBuilder.group({
    Company: [""],
    Designation: [""],
    StartDate: [""],
    EndDate: [""],
    Country: [""],
    City: [""],
    State: [""],
    ContactOwner: [""],
    Nationality: [""],
    Religion: [""],
    Language: [""],
    ProReservation: [""],
    VVIP: [""],
    DateOfBirth: [""],
    Status: [""],
  });
  dropdownList5: any = {};
  dropdownSettings5: any = {};
  dropdownCountry: any = {};
  dropdownState: any = {};
  dropdownNationality: any = {};
  dropdownLanguage: any = {};
  dropdowncompany: any = {};
  dropdownReligion: any = {};
  dropdownProReservation: any = {};
  dropdownDesignation: any = {};

  ngOnInit(): void {
    this.sampleContactExl = environment.import_sample + "Sample_Contact.xlsx";
    this.date_range.startDate = "";
    this.date_range.endDate = "";
    let userid = localStorage.getItem("userId");
    this.userid = this.UserService.decryptData(userid);
    let role_id = localStorage.getItem("roleId");
    this.roleid = this.UserService.decryptData(role_id);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    this.isCollapsed = false;
    this.baseurl = environment.api_url;
    this.resetPagination = false;

    this.StatusForm = this.formBuilder.group({
      Remark: ["", Validators.required],
    });

    this.dropdownCountry = {
      text: "Select Country",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownState = {
      text: "Select State",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownCity = {
      text: "Select City",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownNationality = {
      text: "Select Nationality",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownLanguage = {
      text: "Select Language",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdowncompany = {
      text: "Select company",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownReligion = {
      text: "Select Religion",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownProReservation = {
      text: "Select ProReservation",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownDesignation = {
      text: "Select Designation",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownower = {
      singleSelection: false,
      text: "Select Owner",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    if (this.roleid == 1 || this.permission.Contact_Restore == 1) {
      this.dropdownList5 = [
        { id: 1, itemName: "Active" },
        { id: 2, itemName: "InActive" },
        { id: 3, itemName: "Delete" },
      ];
    } else {
      this.dropdownList5 = [
        { id: 1, itemName: "Active" },
        { id: 2, itemName: "InActive" },
      ];
    }

    this.selectedItems5 = [];
    this.dropdownSettings5 = {
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: 1,
    }; //end

    this.getproreservation();
    this.getcompany();
    this.getlanguage();
    this.getreligion();
    this.getDesignation();
    this.getCountries();
    this.getowner();

    let data = {
      SearchWord: this.searchword,
      Company: "",
      Designation: "",
      BusinessVerticals: "",
      StartDate: "",
      EndDate: "",
      Employee: "",
      Country: "",
      PageNo: this.currentPage + 1,
      Sort: "",
      SortWise: "",
      Export: "",
      ItemPerPages: this.pageSize,
      City: "",
      ContactOwner: "",
      Nationality: "",
      Religion: "",
      Language: "",
      ProReservation: "",
      VVIP: "",
      Status: "",
    };
    this.spinner.show();
    this.UserService.ContactListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.spinner.hide();
        this.currentPage = 0;
        this.contactListArray = res["ContactList"];
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
        this.dataSource.paginator = this.paginator;
        this.totalSize = res["TotalRecord"];
        this.TotalRecord = res["TotalRecord"];
        this.iterator();
        this.resetPagination = true;
      }
    });
  }

  //Multi select
  getowner() {
    this.ownerList = [];
    this.UserService.GetAllUser({ userid: this.userid }).subscribe(
      (response: any) => {
        if (response["result"] == "success") {
          this.showaccount = response;
          for (const accountData of this.showaccount["Data"]) {
            this.ownerList.push({
              id: accountData["UserId"],
              itemName: `${accountData["UserName"]}(${accountData["EmailId"]})${accountData["EmployeeId"]}`,
            });
          }
        } else {
          this.showaccount = [];
        }
      }
    );
  }
  selectedownerName: string = "";
  selectedownerId: string = "";
  selectedowner: any = [];
  onwnerSelect(item: any) {
    this.selectedownerName = "";
    this.selectedownerId = "";
    this.selectedowner.forEach((element) => {
      this.selectedownerName += element["itemName"] + ",";
      this.selectedownerId += element["id"] + ",";
    });
  }

  getcompany() {
    this.CompanyList = [];
    let data = {};
    this.UserService.GetAllCompanyName(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.CompanyArray = res["Data"];
        if (this.CompanyArray.length > 0) {
          for (const companyData of this.CompanyArray) {
            this.CompanyList.push({
              id: companyData["CompanyId"],
              itemName: companyData["CompanyName"],
            });
          }
        }
      } else {
        this.CompanyArray = [];
      }
    });
  }
  selectedCompany: any = [];
  selectedCompanyName: string = "";
  selectedCompanyId: string = "";
  oncompanySelect(item: any) {
    this.selectedCompanyName = "";
    this.selectedCompanyId = "";
    this.selectedCompany.forEach((element) => {
      this.selectedCompanyName += element["itemName"] + ",";
      this.selectedCompanyId += element["id"] + ",";
    });
  }

  selectedReligion: any = [];
  selectedReligionName: string = "";
  selectedReligionId: string = "";
  onReligionSelect(item: any) {
    this.selectedReligionName = "";
    this.selectedReligionId = "";
    this.selectedReligion.forEach((element) => {
      this.selectedReligionName += element["itemName"] + ", ";
      this.selectedReligionId += element["id"] + ", ";
    });
  }
  getreligion() {
    this.ReligionList = [];
    let data = {};
    this.UserService.GetReligion(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.ReligionArray = res["Data"];
        if (this.ReligionArray.length > 0) {
          for (const religionData of this.ReligionArray) {
            this.ReligionList.push({
              id: religionData["ReligionId"],
              itemName: religionData["Name"],
            });
          }
        }
      } else {
        this.ReligionArray = [];
      }
    });
  }

  selectedLanguage: any = [];
  selectedLanguageName: string = "";
  selectedLanguageId: string = "";
  onLanguageSelect(item: any) {
    this.selectedLanguageName = "";
    this.selectedLanguageId = "";
    this.selectedLanguage.forEach((element) => {
      this.selectedLanguageName += element["itemName"] + ", ";
      this.selectedLanguageId += element["id"] + ", ";
    });
  }
  getlanguage() {
    this.LanguageList = [];
    let data = {};
    this.UserService.GetLanguage(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.LanguageArray = res["Data"];
        if (this.LanguageArray.length > 0) {
          for (const languageData of this.LanguageArray) {
            this.LanguageList.push({
              id: languageData["LanguageId"],
              itemName: languageData["Name"],
            });
          }
        }
      } else {
        this.LanguageArray = [];
      }
    });
  }

  selectedReservation: any = [];
  selectedReservationName: string = "";
  selectedReservationId: string = "";
  onReservationSelect(item: any) {
    this.selectedReservationName = "";
    this.selectedReservationId = "";
    this.selectedReservation.forEach((element) => {
      this.selectedReservationName += element["itemName"] + ",";
      this.selectedReservationId += element["id"] + ",";
    });
  }

  getproreservation() {
    this.ReservationList = [];
    let data = {};
    this.UserService.GetProReservation(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.ReservationArray = res["Data"];
        if (this.ReservationArray.length > 0) {
          for (const reservationData of this.ReservationArray) {
            this.ReservationList.push({
              id: reservationData["ProReservationId"],
              itemName: reservationData["Name"],
            });
          }
        }
      } else {
        this.ReservationArray = [];
      }
    });
  }

  getCountries() {
    this.CountryList = [];
    let data = {};
    this.UserService.GetCountries(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.countryListArray = res;
        this.shortcountryname = res["Data"];
        this.shortname = res["Data"]["iso2"];
        for (const countryData of this.countryListArray["Data"]) {
          this.CountryList.push({
            id: countryData["Id"],
            itemName: countryData["Name"],
            shortname: countryData["iso2"],
          });
        }
      } else {
        this.countryListArray = [];
      }
    });
  }

  selectedCountryName: string = "";
  selectedCountryId: string = "";
  selectedCountry: any = [];
  selectedId: any;
  onCountrySelect(item: any) {
    this.selectedCountryName = "";
    this.selectedCountryId = "";
    this.selectedCountry.forEach((element) => {
      this.selectedCountryName += element["itemName"] + ", ";
      this.selectedCountryId += element["id"] + ",";
    });
    this.selectedId = this.selectedCountryId.slice(0, -1);
    this.stateList = [];
    this.selectedState = [];
    this.cityList = [];
    this.selectedCity = [];
    this.getStatesByCountryId(this.selectedId);
  }
  stateArray: any = [];

  getStatesByCountryId(id) {
    this.stateList = [];
    let data = {
      CountryId: id,
    };
    this.UserService.GetStatesByCountryId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.stateArray = res;
        for (const stateData of this.stateArray["Data"]) {
          this.stateList.push({
            id: stateData["Id"],
            itemName: stateData["Name"],
          });
        }
      } else {
        this.stateList = [];
      }
    });
  }

  selectedStateName: string = "";
  selectedStateId: string = "";
  selectedState: any = [];
  onStateSelect(item: any) {
    this.selectedStateName = "";
    this.selectedStateId = "";
    this.selectedState.forEach((element) => {
      this.selectedStateName += element["itemName"];
      this.selectedStateId += element["id"];
    });
    this.cityList = [];
    this.selectedCity = [];
    this.getCitiesByStateId(this.selectedStateId);
  }
  getCitiesByStateId(id) {
    let data = {
      StateId: id,
    };
    this.UserService.GetCitiesByStateId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.cityArray = res;
        for (const cityData of this.cityArray["Data"]) {
          this.cityList.push({
            id: cityData["Id"],
            itemName: cityData["Name"],
          });
        }
      } else {
        this.cityList = [];
      }
    });
  }
  selectedCityName: string = "";
  selectedCityId: string = "";
  selectedCity: any = [];
  onCitySelect(item: any) {
    this.selectedCityName = "";
    this.selectedCityId = "";
    this.selectedCity.forEach((element) => {
      this.selectedCityName += element["itemName"];
      this.selectedCityId += element["id"];
    });
  }
  selectedNationality: any = [];
  selectedNationalityName: string = "";
  selectedNationalityId: string = "";
  onNationalitySelect(item: any) {
    this.selectedNationalityName = "";
    this.selectedNationalityId = "";
    this.selectedNationality.forEach((element) => {
      this.selectedNationalityName += element["itemName"] + ",";
      this.selectedNationalityId += element["id"] + ",";
    });
  }

  dateChangeFun() {
    if (this.date_range && this.date_range != undefined) {
      if (this.date_range.startDate != null) {
        this.start_date = this.datePipe.transform(
          this.date_range.startDate.tz(this.timezone)._d,
          "yyyy-MM-dd"
        );

        this.end_date = this.datePipe.transform(
          this.date_range.endDate.tz(this.timezone)._d,
          "yyyy-MM-dd"
        );
        this.start_date = moment(this.start_date, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        );
        this.end_date = moment(this.end_date, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        );
      } else {
        this.start_date = "";
      }
    }
  }

  getDesignation() {
    this.designationList = [];
    let data = {};
    this.UserService.GetDesignation(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.designationArray = res["Data"];
        if (this.designationArray.length > 0) {
          for (const designationData of this.designationArray) {
            this.designationList.push({
              id: designationData["DesignationID"],
              itemName: designationData["Designation"],
            });
          }
        }
      } else {
        this.designationArray = [];
      }
    });
  }

  selectedDesignation: any = [];
  selectedDesignationName: string = "";
  selectedDesignationId: string = "";
  onDesignationSelect(item: any) {
    this.selectedDesignationName = "";
    this.selectedDesignationId = "";
    this.selectedDesignation.forEach((element) => {
      this.selectedDesignationName += element["itemName"] + ", ";
      this.selectedDesignationId += element["id"] + ", ";
    });
  }

  onItemSelect(item: any) {}
  onSelectAll(items: any) {}
  onDeSelectAll(items: any) {}

  openClosefun() {
    this.isCollapsed = !this.isCollapsed;
  }

  ExportOpenModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm modal-dialog-centered",
    });
  }

  exportConfirm() {
    this.exportcontact();
    this.modalRef.hide();
  }

  exportcontact() {
    this.spinner.show();
    let data = {
      SearchWord: this.searchword,
      Company: this.selectedCompanyId,
      Designation: this.selectedDesignationId,
      BusinessVerticals: "",
      StartDate: "",
      EndDate: "",
      Employee: "",
      Country: this.selectedCountryId,
      PageNo: this.currentPage + 1,
      Sort: this.namesort,
      SortWise: this.type,
      Export: "true",
      ItemPerPages: this.pageSize,
      City: this.selectedCityId,
      ContactOwner: this.selectedownerId,
      Nationality: this.selectedNationalityId,
      Religion: this.selectedReligionId,
      Language: this.selectedLanguageId,
      ProReservation: this.selectedReservationId,
      VVIP: this.registerForm.value.VVIP,
      Status: this.status,
    };
    this.UserService.ContactListFilter(data).subscribe((res: any) => {
      if (res["result"] == "success") {
        this.spinner.hide();
        let exporturl = res["Data"];
        window.open(this.baseurl + "/" + exporturl);
      }
    });
  }

  onChange(event) {
    const target: DataTransfer = <DataTransfer>event.target;
    const regex = /\.(xls|xlsx)$/i; // Case-insensitive match for .xls or .xlsx
    this.isExcelFile = !!regex.exec(target.files[0].name);

    if (!this.isExcelFile) {
      this.toastr.error("Invaild File Format. Only xlsx Files Are Allowed !");
      return;
    }
    this.upfile = target.files[0];

    if (target.files.length > 1) {
      this.inputFile.nativeElement.value = "";
    }
    if (this.isExcelFile) {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        /* for header */
        let arrHeaderMain = wb["Sheets"][wsname];
        if (arrHeaderMain == undefined || arrHeaderMain == null) {
          this.count = 0;
        } else {
          this.arrHeader.push(arrHeaderMain.A1?.h);
          this.arrHeader.push(arrHeaderMain.B1?.h);
          this.arrHeader.push(arrHeaderMain.C1?.h);
          this.arrHeader.push(arrHeaderMain.D1?.h);
          this.arrHeader.push(arrHeaderMain.E1?.h);
          this.arrHeader.push(arrHeaderMain.F1?.h);
          this.arrHeader.push(arrHeaderMain.G1?.h);
          this.arrHeader.push(arrHeaderMain.H1?.h);
          this.arrHeader.push(arrHeaderMain.I1?.h);
          this.arrHeader.push(arrHeaderMain.J1?.h);
          this.arrHeader.push(arrHeaderMain.K1?.h);
          this.arrHeader.push(arrHeaderMain.L1?.h);
          this.arrHeader.push(arrHeaderMain.M1?.h);
          this.arrHeader.push(arrHeaderMain.N1?.h);
          this.arrHeader.push(arrHeaderMain.O1?.h);
          this.arrHeader.push(arrHeaderMain.P1?.h);
          this.arrHeader.push(arrHeaderMain.Q1?.h);
          this.arrHeader.push(arrHeaderMain.R1?.h);
          this.arrHeader.push(arrHeaderMain.S1?.h);
          this.arrHeader.push(arrHeaderMain.T1?.h);
          this.arrHeader.push(arrHeaderMain.U1?.h);
          this.arrHeader.push(arrHeaderMain.V1?.h);
          this.arrHeader.push(arrHeaderMain.W1?.h);
        }

        /* save data */
        this.data = XLSX.utils.sheet_to_json(ws);
      };

      reader.readAsBinaryString(target.files[0]);

      reader.onloadend = (e) => {
        this.showcontact = Object.keys(this.data);
        this.count = 0;
        let arr = [
          "ContactName",
          "Mobile",
          "Landline",
          "WhatsappNumber",
          "Email",
          "Country",
          "State",
          "City",
          "DateOfBirth",
          "Address1",
          "Address2",
          "Company",
          "Designation",
          "ContactOwner",
          "Nationality",
          "Religion",
          "Language",
          "ProReservation",
          "Gender",
          "VVIP",
          "FactoryVisit",
          "FactoryVisitComments",
          "Comments",
        ];

        if (
          JSON.stringify(this.arrHeader) === JSON.stringify(arr) &&
          this.arrHeader.length > 0
        ) {
          if (this.showcontact.length > 0) {
            if (this.showcontact.length <= 1000) {
              this.count = 2;
            } else {
              this.count = 3;
            }
          } else {
            this.count = 1;
          }
        } else {
          this.count = 0;
        }
      };
    } else {
      this.inputFile.nativeElement.value = "";
    }
  }

  //abhishek
  import() {
    if (this.data == undefined) {
      this.toastr.error("Please Select a valid xlsx file");
      return null;
    } else if (this.count == 0) {
      this.toastr.error("Invalid Template!");
      return;
    } else if (this.count == 1) {
      this.toastr.error("File should not be empty !");
      return;
    } else if (this.count == 3) {
      this.toastr.error("Maximum 1000 records are allowed !");
      return;
    } else {
      this.spinner.show();
      this.UserService.ImportContactList(this.data).subscribe((res) => {
        if (res["result"] == "success") {
          this.spinner.hide();
          this.showimport.nativeElement.click();
          this.Totalrec = res["TotalRecord"];
          this.invalid = res["InvaildRow"];
          this.valid = this.Totalrec - this.invalid;
          this.dataarray = res["Data"];
          this.toastr.success("Contact save successfully");
          this.modalRef.show();
          this.toastr.success("Contact save successfully");
        } else if (res["result"] == "Failed") {
          this.spinner.hide();
          this.showimport.nativeElement.click();
          this.isValid = true;
          this.Totalrec = res["TotalRecord"];
          this.invalid = res["InvaildRow"];
          this.valid = this.Totalrec - this.invalid;
          this.dataarray = res["Data"];
          this.modalRef.show();
        } else {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
          this.modalRef.hide();
        }
      });
    }
  }

  public handlePage(e: any) {
    this.spinner.show();
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.iterator();
    //abhishek
    let data = {
      SearchWord: this.searchword,
      Company: this.selectedCompanyId,
      Designation: this.selectedDesignationId,
      BusinessVerticals: "",
      StartDate: "",
      EndDate: "",
      Employee: "",
      Country: this.selectedCountryId,
      PageNo: this.currentPage + 1,
      Sort: this.namesort,
      SortWise: this.type,
      Export: "",
      ItemPerPages: this.pageSize,
      City: this.selectedCityId,
      ContactOwner: this.selectedownerId,
      Nationality: this.selectedNationalityId,
      Religion: this.selectedReligionId,
      Language: this.selectedLanguageId,
      ProReservation: this.selectedReservationId,
      VVIP: this.registerForm.value.VVIP,
      Status: this.status,
    };

    this.UserService.ContactListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
        this.totalSize = this.TotalRecord;
      }
    });
  }

  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.contactListArray.slice(start, end);
    this.dataSource = part;
  }

  onSortData(sort: Sort) {
    this.spinner.show();
    this.changeDetectorRefs.detectChanges();
    this.sortData = [];
    this.sortData = { column: sort.active, direction: sort.direction };
    this.type = sort.direction;
    this.namesort = sort.active;
    if (sort.direction == "asc") {
      this.upicon = true;
      this.downicon = false;
    } else {
      this.upicon = false;
      this.downicon = true;
    }
    this.columnsort = sort.active;

    //abhishek
    let data = {
      SearchWord: this.searchword,
      Company: this.selectedCompanyId,
      Designation: this.selectedDesignationId,
      BusinessVerticals: "",
      StartDate: "",
      EndDate: "",
      Employee: "",
      Country: this.selectedCountryId,
      PageNo: this.currentPage + 1,
      Sort: sort.active,
      SortWise: sort.direction,
      Export: "",
      ItemPerPages: this.pageSize,
      City: this.selectedCityId,
      ContactOwner: this.selectedownerId,
      Nationality: this.selectedNationalityId,
      Religion: this.selectedReligionId,
      Language: this.selectedLanguageId,
      ProReservation: this.selectedReservationId,
      VVIP: this.registerForm.value.VVIP,
      Status: this.status,
    };
    this.dataSource = [];
    this.UserService.ContactListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
        this.totalSize = this.TotalRecord;
      }
    });
  }

  searchword: any = "";
  edit(id) {
    let encryptid = this.UserService.encryptData(id);
    encryptid = encryptid
      .toString()
      .replace("=", "Ar1t")
      .replace("/", "FGH")
      .replace("+", "THD");
    this.router.navigate(["/contacts/editcontact", encryptid]);
  }

  view(eid) {
    let encryptid = this.UserService.encryptData(eid);
    encryptid = encryptid
      .toString()
      .replace("=", "Ar1t")
      .replace("/", "FGH")
      .replace("+", "THD");
    this.router.navigate(["/contacts/contactdetail", encryptid]);
  }

  modeldisplay3: any = false;
  applyback: any;
  openStatusModel(
    template: TemplateRef<any>,
    ContactId: any,
    state: any,
    data: any
  ) {
    this.status_id = ContactId;
    this.sta_type = state;
    this.name = data.ContactName;
    this.ConStatus = data.StatusName;
    this.modeldisplay3 = true;
    this.applyback = true;
    this.modalRef = this.modalService.show(template, {
      class: "modal-md modal-dialog-centered",
    });
  }

  hidemodel2() {
    this.modeldisplay3 = false;
  }

  statusConfirm() {
    this.makeActiveInactive();
    this.modalRef.hide();
  }

  makeActiveInactive() {
    this.submitted1 = true;
    if (this.StatusForm.valid) {
      const data = {
        ContactId: this.status_id,
        Status: this.sta_type,
        StatusRemark: this.StatusForm.value.Remark,
      };
      this.spinner.show();
      this.UserService.UpdateContactStatus(data).subscribe(
        (res: any) => {
          if (res["result"] == "success") {
            this.spinner.hide();
            this.toastr.success(res["Msg"], "Success!");
            this.modalRef.hide();
            this.modeldisplay3 = false;
            this.router
              .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
              .then(() => {
                this.router.navigateByUrl("/contacts/contacts-list");
              });
          } else {
            this.err_message = res.Msg;
            this.spinner.hide();
          }
        },
        (err: any) => {
          this.spinner.hide();
        }
      );
      this.submitted1 = false;
    }
  }

  clearEndDate() {
    this.date_range = null;
  }

  deleteOpenModal(template: TemplateRef<any>, data, id) {
    if (data) {
      this.deleteId = data.ContactId;
      this.file = data.ContactName;
      this.delstatus = id;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  decline() {
    this.isValid = false;
    this.modalRef.hide();
  }

  clear() {
    this.StatusForm.get("Remark").patchValue("");
  }

  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }

  deleteConfirm() {
    this.deletecontact();
    this.modalRef.hide();
  }

  deletecontact() {
    this.spinner.show();
    this.UserService.UpdateContactStatus({
      ContactId: this.deleteId,
      Status: this.delstatus,
    }).subscribe((response: any) => {
      if (response["result"] == "success") {
        this.spinner.hide();
        this.toastr.success("Contact Deleted Successfully!");
        this.router
          .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl("/contacts/contacts-list");
          });
      } else {
        this.err_message = response.Msg;
      }
    });
  }

  applyFilter() {
    this.spinner.show();
    let data = {
      SearchWord: this.searchword,
      Company: this.selectedCompanyId,
      Designation: this.selectedDesignationId,
      BusinessVerticals: "",
      StartDate: "",
      EndDate: "",
      Employee: "",
      Country: this.selectedCountryId,
      PageNo: this.currentPage + 1,
      Sort: "",
      SortWise: "",
      Export: "",
      ItemPerPages: this.pageSize,
      City: this.selectedCityId,
      ContactOwner: this.selectedownerId,
      Nationality: this.selectedNationalityId,
      Religion: this.selectedReligionId,
      Language: this.selectedLanguageId,
      ProReservation: this.selectedReservationId,
      VVIP: this.registerForm.value.VVIP,
      Status: this.status,
    };
    this.UserService.ContactListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.spinner.hide();
        this.TotalRecord = res["TotalRecord"];
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
        this.totalSize = this.TotalRecord;
      }
    });
  }

  clearUserData() {
    const previousValue = this.searchword;
    this.searchword = "";
    if (
      previousValue &&
      previousValue.length > 0 &&
      previousValue !== this.searchword
    ) {
      this.clearEvent.emit();
    }
  }

  tr: any;
  onSubmit() {
    let start, end;
    this.showTable = false;
    this.spinner.show();
    if (
      this.date_range.startDate &&
      this.date_range.startDate != "" &&
      this.date_range.endDate &&
      this.date_range.endDate != ""
    ) {
      start = this.datePipe.transform(this.date_range.startDate, "yyyy-MM-dd");
      end = this.datePipe.transform(this.date_range.endDate, "yyyy-MM-dd");
    } else {
      start = "";
      end = "";
    }

    this.status = Array.prototype.map
      .call(this.selectedItems5, function (item) {
        return item.id;
      })
      .join(",");
    let data = {
      SearchWord: "",
      Company: this.selectedCompanyId,
      Designation: this.selectedDesignationId,
      StartDate: start,
      EndDate: end,
      Country: this.selectedCountryId,
      PageNo: this.currentPage + 1,
      Sort: "",
      SortWise: "",
      Export: "",
      ItemPerPages: this.pageSize,
      City: this.selectedCityId,
      State: this.selectedStateId,
      ContactOwner: this.selectedownerId,
      Nationality: this.selectedNationalityId,
      Religion: this.selectedReligionId,
      Language: this.selectedLanguageId,
      ProReservation: this.selectedReservationId,
      VVIP: this.registerForm.value.VVIP,
      Status: this.status,
    };
    this.resetPagination = false;
    this.UserService.ContactListFilter(data).subscribe(
      (res) => {
        if (res["result"] == "success") {
          this.spinner.hide();
          this.showTable = true;
          this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
          this.TotalRecord = res["TotalRecord"];
          this.tr = res["TotalRecord"];
          this.totalSize = this.TotalRecord;
          this.router.navigate(["/contacts/contacts-list"]);
        } else if (res["result"] == "Failed") {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(res["Message"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );
  }

  resetData() {
    this.selectedCompanyId = "";
    this.selectedDesignationId = "";
    this.selectedCountryId = "";
    this.selectedCityId = "";
    this.selectedStateId = "";
    this.selectedownerId = "";
    this.selectedNationalityId = "";
    this.selectedReligionId = "";
    this.selectedLanguageId = "";
    this.selectedReservationId = "";
    this.selectedselect_date = [];
    this.selecteddate_range = [];
    this.registerForm.reset();
    this.totalSize = this.tr;
    this.ngOnInit();
    this.isCollapsed = true;
  }

  //restore
  restoreOpenModal(template: TemplateRef<any>, data) {
    if (data) {
      this.restoreId = data.ContactId;
      this.files = data.ContactName;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  restoreConfirm() {
    this.restorecontact();
    this.modalRef.hide();
  }

  restorecontact() {
    this.spinner.show();
    this.UserService.RestoreContact({ ContactId: this.restoreId }).subscribe(
      (response: any) => {
        if (response["result"] == "success") {
          this.spinner.hide();
          this.toastr.success("Contact Restore Successfully!");
          this.router
            .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
            .then(() => {
              this.router.navigateByUrl("/contacts/contacts-list");
            });
        } else {
          this.err_message = response.Msg;
        }
      }
    );
  }

  decline1() {
    this.modalRef.hide();
    window.location.reload();
  }

  rtnView() {
    this.router
      .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
      .then(() => {
        this.router.navigateByUrl("/contacts/contacts-list");
      });
  }
}
